<template lang="pug">
main.modal-wrapper
    svg-icon.close-modal.cursor(
        v-if="!isCcloneEvent && !isCcloneFirstParty"
        name='close' size="small" @click.native="closeForm()")

    EventsModal(
        :class="{ 'slide-panel-right': displayEventsModal }"
        :displayCriteriaList="displayEventsModal"
        :ccloneMode="ccloneMode.selectedMode"
        :isCcloneEvent="isCcloneEvent"
        :isCcloneFirstParty="isCcloneFirstParty"
        :selectionHistory="currentSelectedEvent"
        :firstPartyHistory="firstPartyHistory")

    div.modal-main(:class="{ 'ui-disabled': displayEventsModal }")

        header.modal-header
            SectionHeader(:title="formTitle")
                template(slot='actionLeft')
                    div.btn-cclone-advance-mode(
                        :class="{'is-active': advanceModeActivated }"
                        @click="activateAdvanceMode()") Advanced Mode

        div.modal-body

            //- LABEL
            div.form-section
                div.form-subsection
                    div.form-label__required
                        label CClone Name
                    input.form-input(
                        v-model.trim="ccloneInfo.label"
                        placeholder="Choose a nice name for your cclone"
                        autofocus
                        id="label"
                        name="label"
                        @keyup="debouncedCheckLabel(ccloneInfo.label)"
                        @keyup.delete="debouncedCheckLabel(ccloneInfo.label)"
                        v-validate="'max:200|required|ascii'"
                        :class="{'ui-disabled': isLoading}"
                        type="text")
                    span.form-validate-error {{ errors.first('label') }}
                    span.form-validate-error(v-if="labelAlreadyExists") This name is not available

            //- DATE
            div.form-section
                div.section-title Testing period

                div.l-flex-row.has-gutter_medium
                    div.form-subsection.w-180
                        div.form-label__required
                            label(for="start_date") Activation Date
                        el-date-picker(
                            v-model="startDate"
                            id="start_date"
                            name="start_date"
                            clearable=false
                            type="date"
                            :picker-options="startDateOptions"
                            :default-value="startDate"
                            v-validate="'date_format:YYYY-MM-DD|required'")
                        span.form-validate-error {{ errors.first('start_date') }}
                    div.form-subsection.w-180
                        div.form-label__required
                            label(for="end_date") End Date
                        el-date-picker(
                            v-model="endDate"
                            id="end_date"
                            name="end_date"
                            clearable=false
                            type="date"
                            :picker-options="endDateOptions"
                            :default-value="endDate"
                            v-validate="'date_format:YYYY-MM-DD|required'")
                        span.form-validate-error {{ errors.first('end_date') }}

            //- CCLONE MODE
            div.form-section.section-cclone-mode
                div.section-title CClone mode
                div.l-flex-row.has-gutter_medium
                    div.form-subsection.w-180
                        select.form-select.big.square.w-180(
                            id="cclone-mode"
                            name="cclone-mode"
                            v-model="ccloneMode.selectedMode")
                            option(
                                v-for="item in ccloneModes",
                                :key="item.id",
                                :label="item.label",
                                :value="item.id") {{ item.label }}

                    div.form-subsection.l-flex-column.w-180(v-if="showFirstPartyButton || advanceModeActivated && showThirdPartyCheckBoxes")

                        div.form-cclone-mode-1stparty.l-flex-column(v-if="showFirstPartyButton")
                            button.btn-form.is-highlight(
                                :class="{'ui-disabled': isLoading}"
                                @click.prevent="displaySelectFirstPartyDataModal()") Select 1st Party
                            span.extra-info(v-if="isLoading")
                                spinner.l-flex-row--center.l-align-center(width="30" height="30")
                            span.form-validate-error(v-else-if="firstPartySelection.length < 5") Please select at least 5 criteria
                            span.extra-info(v-else) {{ infoTotalSelectedCriteria }}


                        div.form-cclone-mode-3rdparty(v-if="advanceModeActivated && showThirdPartyCheckBoxes")
                            div.checkbox-cart
                                input(
                                    id="clusters-only"
                                    v-model="ccloneMode.clusterOnly"
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox")
                                label(for="clusters-only" :class="{'is-active': ccloneMode.clusterOnly === '1'}") Clusters only

                            div.checkbox-cart
                                input(
                                    id="versioned-profiles"
                                    v-model="ccloneMode.versionedProfiles"
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox")
                                label(for="versioned-profiles" :class="{'is-active': ccloneMode.versionedProfiles === '1'}") Versioned profiles

            //- EVENTS
            div.form-section.form-section-cclone
                div.section-title Events
                div.l-flex-row.has-gutter_medium
                    //- POSITIVE
                    div.form-subsection.w-180
                        div.form-label__required
                            label Positive event
                        button.btn-form.is-highlight(
                            :class="{'ui-disabled': isLoading}"
                            @click.prevent="displayPositiveEventsModal()") Select positive event
                        div.cclone-breadcrumb-path(v-if="isLoading")
                            spinner.l-flex-row--center.l-align-center(width="30" height="30")
                        div.cclone-breadcrumb-path(v-else-if="displayPositiveBreadcrumbs")
                            div.breadcrumb-path-cclone {{ upperfirstLabel(headPositiveCriteriaBreadcrumb) }}
                            div.breadcrumb-path-cclone ...
                            div.breadcrumb-path-cclone {{ lastPositiveCriteriaBreadcrumb }}
                    //- UNIVERSE
                    div.form-subsection.w-180
                        div.form-label__required.l-flex-row
                            label Universe
                        button.btn-form.is-highlight(
                            :class="{'ui-disabled': isLoading}"
                            @click.prevent="displayNegativeEventsModal()") Define Universe
                        div.cclone-breadcrumb-path(v-if="isLoading")
                            spinner.l-flex-row--center.l-align-center(width="30" height="30")
                        div.cclone-breadcrumb-path(v-else-if="displayNegativeBreadcrumbs")
                            div.breadcrumb-path-cclone {{ upperfirstLabel(headNegativeCriteriaBreadcrumb) }}
                            div.breadcrumb-path-cclone ...
                            div.breadcrumb-path-cclone {{ lastNegativeCriteriaBreadcrumb }}
                        div.cclone-breadcrumb-path(v-else)
                            div.breadcrumb-path-cclone {{ dataBaseChildLabel }}

                div.l-flex-row.has-gutter_medium(v-if="advanceModeActivated")
                    //- MAX POSITIVE
                    div.form-subsection.w-180
                        div.form-label__required
                            label(for="max_positive_event") Max. positive event
                        input.form-input(
                            v-model.number="ccloneInfo.max_positive_event"
                            autofocus
                            id="max_positive_event"
                            name="max_positive_event"
                            v-validate="'min_value:1|max_value:400000|decimal:no|required'"
                            type="number")
                        span.form-validate-error {{ errors.first('max_positive_event') }}
                    //- MAX POSITIVE
                    div.form-subsection.w-180
                        div.form-label__required
                            label(for="max_negative_event") Max. negative event
                        input.form-input(
                            v-model.number="ccloneInfo.max_negative_event"
                            autofocus
                            id="max_negative_event"
                            name="max_negative_event"
                            v-validate="'min_value:1|max_value:400000|decimal:no|required'"
                            type="number")
                        span.form-validate-error {{ errors.first('max_negative_event') }}

            div.form-section.form-section-cclone(v-if="advanceModeActivated")
                div.section-title Algorithm parameters

                div.l-flex-row.has-gutter_medium
                    div.form-subsection.w-180

                        div.form-label
                            label Depth level
                        div.cclone-depth

                            div.l-flex-row--between.cclone-depth-row(
                                v-for="(depth, idx) in depthList",
                                :key="idx"
                                @click.stop="setMaxDepth(idx)"
                                :class="{'is-active': ccloneInfo.model_params.maxdepth > idx }"
                            )
                                div.depth-label {{ depth.label }}
                                div.depth-pyramid
                                    svg-icon(:name="depth.value" :title="`${depth.label} depth`")

                    div.form-subsection.w-180
                        div.form-label__required
                            label(for="min_bucket") Min. Bucket
                        input.form-input(
                            v-model="ccloneInfo.model_params.minbucket"
                            autofocus
                            id="min_bucket"
                            name="min_bucket"
                            v-validate="'min_value:0|max_value:400000|decimal:no|required'"
                            type="number")
                        span.form-validate-error {{ errors.first('min_bucket') }}

        //- Footer Cclone form
        footer.modal-footer
            div.footer-content.l-flex-row--between
                button.btn.btn--medium.btn--round(@click="closeForm()") Cancel
                button.btn.btn--medium.btn--round.btn-rev(:class="{'is-disabled': disableCreate }" @click="saveForm()") {{ confirmLabel }}

</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { cloneDeep, debounce, find, get, includes, isEmpty, isArray, isEqual, isNil, last, size, toNumber, upperFirst } from 'lodash'

import SectionHeader from '@/components/common/SectionHeader'
import EventsModal from '@/components/onBoarding/EventsModal'
import dayjs from 'dayjs'

const FIRST_PARTY_MODE = '1stParty'
const THIRD_PARTY_MODE = '3rdParty'
const FIRST_AND_THIRD_PARTY_MODE = '1st&3rdParty'

export default {
    name: 'CcloneForm',

    components: { EventsModal, SectionHeader },

    mounted() {
        if (this.isEditing) {
            this.setMainDataOnEdit()
            // TODO: remove this commented code (and refactor) during sharings integration in cclone form
            // if (this.hierarchyIsAlreadyRetrieved) {
            this.setAdvancedDataOnEdit()
            // } else {
            //    this.isLoading = true
            // }
        }
        //this.retrieveNeededHierarchy()
    },

    watch: {
        displayEventsModal: {
            handler: function(newValue, oldValue) {
                if (!isEqual(newValue, oldValue) && !newValue) {
                    this.isCcloneEvent = false
                    this.isCcloneFirstParty = false
                }
            }
        },

        startDate: {
            handler: function(newValue, oldValue) {
                if (!this.isEditing && !isEqual(newValue, oldValue)) {
                    this.endDate = dayjs(newValue)
                        .add(30, 'day')
                        .toDate() //for any reason, moment adding 29 days results in +30 days in the app
                }
            }
        },

        ccloneMode: {
            handler: function(newValue) {
                if (this.isEditing) {
                    if (newValue.selectedMode === FIRST_PARTY_MODE || newValue.selectedMode === FIRST_AND_THIRD_PARTY_MODE) {
                        const _selectedCcloneFirstPartyData = get(this.ccloneToEdit.settings[FIRST_PARTY_MODE], 'allowed_criteria', null)
                        if (!isNil(_selectedCcloneFirstPartyData)) {
                            let _firstPartySelection = []
                            for (const _data of this.firstPartyData) {
                                // we need to retrieve item from store to get its jsonKey.name
                                const sameElemFromStore = find(_selectedCcloneFirstPartyData, _item => {
                                    return isEqual(_item.ids, _data.jsonKey.ids) && _item.type === _data.jsonKey.type
                                })
                                if (!isNil(sameElemFromStore)) {
                                    _firstPartySelection = [..._firstPartySelection, _data.jsonKey.name]
                                }
                            }
                            if (!isEmpty(_firstPartySelection)) {
                                this.setFirstPartySelection({ items: _firstPartySelection })
                            }
                        }
                    }
                }
            },
            deep: true
        },

        firstPartySelection: {
            handler: function(newValue, oldValue) {
                if (!isEqual(newValue, oldValue) && !isEmpty(oldValue)) this.firstPartySelectionUpdated = true
            }
        }
    },

    data() {
        return {
            depthList: [
                {
                    label: '1st',
                    value: 'depth-1'
                },
                {
                    label: '2nd',
                    value: 'depth-2'
                },
                {
                    label: '3rd',
                    value: 'depth-3'
                },
                {
                    label: '4th',
                    value: 'depth-4'
                },
                {
                    label: '5th',
                    value: 'depth-5'
                }
            ],
            ccloneInfo: {
                bigsea: 'YES',
                label: null,
                model_params: {
                    algorithm: 'DecisionTree',
                    method: 'Anova',
                    complexity: 0.0001,
                    minbucket: '0',
                    maxdepth: '5'
                },
                max_positive_event: 40000,
                max_negative_event: 40000
            },
            ccloneModes: [
                { id: FIRST_PARTY_MODE, label: '1st Party' },
                { id: THIRD_PARTY_MODE, label: '3rd Party' },
                { id: FIRST_AND_THIRD_PARTY_MODE, label: '1st & 3rd Party' }
            ],
            advanceModeActivated: false,
            labelAlreadyExists: false,
            ccloneMode: {
                selectedMode: THIRD_PARTY_MODE,
                clusterOnly: '0',
                versionedProfiles: '1'
            },
            startDate: dayjs(new Date()).subtract(30, 'days'),
            endDate: new Date(),
            currentSelectedEvent: null,
            isCcloneEvent: false,
            isCcloneFirstParty: false,
            processing: false,
            isLoading: false,
            firstPartySelectionUpdated: false
        }
    },

    computed: {
        ...mapState('ui/cclone', {
            displayEventsModal: state => state.displayModal.events,
            isEditing: state => state.isEditing,
            eventType: state => state.eventType,
            firstPartySelection: state => state.firstPartySelection,
            firstPartySelectAll: state => state.firstPartySelectAll,
            positiveEvent: state => state.selectedEvents.positive,
            negativeEvent: state => state.selectedEvents.negative,
            databaseEvent: state => state.selectedEvents.database,
            ccloneCriteriaTypes: state => state.criteriaTypes,
            selectedCcloneId: state => state.selectedRowId
        }),

        ...mapState('data/audience', {
            audienceList: state => state.list
        }),

        ...mapState('data/behavioral', {
            behavioralList: state => state.list
        }),

        ...mapState('data/demographic', {
            demographicList: state => state.list
        }),

        ...mapState('data/customTaxonomies', {
            customTaxonomies: state => state.customTaxonomies,
            hierarchies: state => state.hierarchies,
            hierarchyIsAlreadyRetrieved: state => state.hierarchyIsAlreadyRetrieved
        }),

        ...mapGetters('ui/builder', ['getCriteriaPath']),
        ...mapGetters('ui/cclone', ['getFirstPartyData']),
        ...mapGetters('data/cclone', ['getItemById', 'getFormattedCclones']),

        formTitle() {
            return this.isEditing ? 'Edit Cclone' : 'Create Cclone'
        },

        confirmLabel() {
            return this.isEditing ? 'Edit' : 'Create'
        },

        ccloneToEdit() {
            const _info = this.getItemById({ id: this.selectedCcloneId })
            // @TODO error notification
            if (_info === false) return null
            return _info
        },

        firstPartyData() {
            return [...this.getFirstPartyData(), ...this.reformatedHierarchies]
        },

        reformatedHierarchies() {
            const hierarchies = []
            for (const hierarchy in this.hierarchies) {
                const clone = this.hierarchies[hierarchy]
                for (const sub in clone) {
                    const ids = []
                    ids.push(clone[sub]['id'])
                    clone[sub]['ids'] = ids
                    clone[sub]['parentId'] = hierarchy
                    hierarchies.push(clone[sub])
                }
            }
            return hierarchies
        },

        positiveEventsData() {
            return [...this.firstPartyData, ...this.audienceList]
        },

        negativeEventsData() {
            return [...this.positiveEventsData, ...this.behavioralList, ...this.demographicList]
        },

        // Breadcrumb
        displayPositiveBreadcrumbs() {
            return !isNil(this.positiveEvent)
        },

        displayNegativeBreadcrumbs() {
            return !isNil(this.negativeEvent) && !this.databaseEvent
        },

        positiveCriteriaBreadcrumb() {
            return this.getCriteriaPath({ menuCriteriaType: this.ccloneCriteriaTypes.positive.current })
        },

        headPositiveCriteriaBreadcrumb() {
            return last(this.positiveCriteriaBreadcrumb)
        },

        negativeCriteriaBreadcrumb() {
            return this.getCriteriaPath({ menuCriteriaType: this.ccloneCriteriaTypes.negative.current })
        },

        headNegativeCriteriaBreadcrumb() {
            return last(this.negativeCriteriaBreadcrumb)
        },

        lastPositiveCriteriaBreadcrumb() {
            return get(this.positiveEvent, 'label', '')
        },

        lastNegativeCriteriaBreadcrumb() {
            return get(this.negativeEvent, 'label', '')
        },

        ccloneList() {
            return this.getFormattedCclones()
        },

        ccloneInStore() {
            return this.getItemById({ id: this.selectedCcloneId })
        },

        ccloneHasBeenChanged() {
            // General Cclone infos, for edition
            if (!this.isEditing) return true
            if (this.ccloneInStore.label !== this.ccloneInfo.label) return true
            else if (dayjs(this.ccloneInStore.start_date).format('YYYY-MM-DD 00:00:00') !== dayjs(this.startDate).format('YYYY-MM-DD 00:00:00')) return true
            else if (this.ccloneInStore.end_date !== dayjs(this.endDate).format('YYYY-MM-DD 00:00:00')) return true

            //Specific 1st and 3rd party cclones
            if (this.ccloneInStore.settings.hasOwnProperty('3rdParty') && !this.ccloneInStore.settings.hasOwnProperty('1stParty')) {
                if (this.ccloneMode.selectedMode !== '3rdParty' || this.firstPartySelectionUpdated) return true
                else if (this.formatBooleans(this.ccloneMode.clusterOnly) !== this.ccloneInStore.settings['3rdParty'].cluster_only) return true
                else if (this.formatBooleans(this.ccloneMode.versionedProfiles) !== this.ccloneInStore.settings['3rdParty'].is_profile_versioned) return true
            }

            //Specific 1st party cclones
            else if (this.ccloneInStore.settings.hasOwnProperty('1stParty') && !this.ccloneInStore.settings.hasOwnProperty('3rdParty')) {
                if (this.ccloneMode.selectedMode !== '1stParty' || this.firstPartySelectionUpdated) return true
            }

            //Specific 3rd party cclones
            else if (this.ccloneInStore.settings.hasOwnProperty('1stParty') && this.ccloneInStore.settings.hasOwnProperty('3rdParty')) {
                if (this.ccloneMode.selectedMode !== '1st&3rdParty') return true
                else if (this.formatBooleans(this.ccloneMode.clusterOnly) !== this.ccloneInStore.settings['3rdParty'].cluster_only) return true
                else if (this.formatBooleans(this.ccloneMode.versionedProfiles) !== this.ccloneInStore.settings['3rdParty'].is_profile_versioned) return true
            }

            //Positive and Negative events
            if (this.ccloneInStore.negative_events === '' && !isNil(this.negativeEvent)) return true
            else if (this.ccloneInStore.negative_events !== '') {
                if (isNil(this.negativeEvent)) return true
                if (JSON.parse(this.ccloneInStore.negative_events).ids[0] !== this.negativeEvent.jsonKey.ids[0]) return true
            }
            let positiveEventId
            if (this.positiveEvent.ids) {
                positiveEventId = this.positiveEvent.ids
            } else if (this.positiveEvent.id) {
                positiveEventId = isArray(this.positiveEvent.id) ? [...this.positiveEvent.id] : [this.positiveEvent.id]
            }

            if (!isEqual(positiveEventId, JSON.parse(this.ccloneInStore.positive_events).ids)) return true

            //Advances Settings
            if (this.ccloneInfo.max_negative_event !== toNumber(this.ccloneInStore.max_negative_event)) return true
            if (this.ccloneInfo.max_positive_event !== toNumber(this.ccloneInStore.max_positive_event)) return true

            const modelParams = JSON.parse(this.ccloneInStore.model_params)

            if (this.ccloneInfo.model_params.maxdepth != modelParams.maxdepth) return true
            if (this.ccloneInfo.model_params.minbucket !== modelParams.minbucket) return true

            return false
        },

        disableCreate() {
            return this.processing
                ? true
                : isEmpty(this.ccloneInfo.label) ||
                      size(this.errors.items) > 0 ||
                      this.labelAlreadyExists ||
                      isNil(this.positiveEvent) ||
                      (this.ccloneMode.selectedMode !== '3rdParty' && this.firstPartySelection.length < 5) ||
                      !this.ccloneHasBeenChanged
        },

        startDateOptions() {
            return {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    const minNow = new Date()
                    const minDate = minNow.setTime(minNow.getTime() - 24 * 60 * 60 * 1000 * 30) // - 30 days from now
                    const maxNow = new Date()
                    const maxDate = maxNow.setTime(maxNow.getTime() + 24 * 60 * 60 * 1000 * 90) // + 90 days from now
                    return !(time.getTime() + 86400000 > minDate && time.getTime() < maxDate)
                }
            }
        },

        endDateOptions() {
            const startDate = this.startDate
            return {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    const minStartDate = dayjs(startDate).toDate() // day after min start date
                    const minDate = minStartDate.setTime(minStartDate.getTime() + 24 * 60 * 60 * 1000 * 1)

                    const maxStartDate = dayjs(startDate).toDate()
                    const maxDate = maxStartDate.setTime(maxStartDate.getTime() + 24 * 60 * 60 * 1000 * 30) // + 30 days from now

                    return !(time.getTime() + 86400000 > minDate && time.getTime() < maxDate)
                }
            }
        },

        showFirstPartyButton() {
            return this.ccloneMode.selectedMode !== THIRD_PARTY_MODE
        },

        showThirdPartyCheckBoxes() {
            return this.ccloneMode.selectedMode !== FIRST_PARTY_MODE
        },

        dataBaseChildLabel() {
            return this.ccloneMode.selectedMode === FIRST_PARTY_MODE ? '1st Party Universe' : 'Full database'
        },

        infoTotalSelectedCriteria() {
            return isEmpty(this.firstPartySelection) ? '' : `${size(this.firstPartySelection)} criteria selected`
        },

        firstPartyHistory() {
            return {
                selection: this.firstPartySelection,
                selectAll: this.firstPartySelectAll
            }
        }
    },

    methods: {
        ...mapMutations('ui/cclone', [
            'setDisplayModal',
            'setEventType',
            'resetEventsStoreOnCcloneFormClose',
            'setCriteriaType',
            'setIsEditing',
            'setFirstPartySelection',
            'setSelectedEvent'
        ]),

        ...mapMutations('data/customTaxonomies', ['setHierarchyIsAlreadyRetrieved']),

        ...mapActions('ui/cclone', ['checkCCloneLabels']),

        ...mapActions('data/cclone', ['createCclone', 'editCclone']),

        ...mapActions('data/customTaxonomies', ['retrieveItems']),
        ...mapActions('dashboardAccount', ['retrieveCcloneList']),

        activateAdvanceMode() {
            this.advanceModeActivated = !this.advanceModeActivated
        },

        closeForm() {
            this.processing = false
            this.setIsEditing({ isEditing: false })
            this.setDisplayModal({ modal: 'ccloneCreation', isDisplayed: false })
            this.resetEventsStoreOnCcloneFormClose()
        },

        upperfirstLabel(label) {
            if (label === 'browser') return 'Browsers'
            if (label === 'device') return 'Devices'
            if (label === 'os') return 'Operating Systems'
            if (label === 'isp') return 'Internet Service Providers'
            return upperFirst(label)
        },

        setMainDataOnEdit() {
            const _ccloneInfos = cloneDeep(this.ccloneToEdit)
            // main infos
            this.startDate = new Date(_ccloneInfos.start_date)
            this.endDate = new Date(_ccloneInfos.end_date)
            this.ccloneInfo = {
                bigsea: _ccloneInfos.bigsea,
                label: _ccloneInfos.label,
                model_params: JSON.parse(_ccloneInfos.model_params),
                max_positive_event: toNumber(_ccloneInfos.max_positive_event),
                max_negative_event: toNumber(_ccloneInfos.max_negative_event)
            }
            // main cclone mode
            this.ccloneMode.selectedMode = size(Object.keys(_ccloneInfos.settings)) > 1 ? FIRST_AND_THIRD_PARTY_MODE : Object.keys(_ccloneInfos.settings)[0]
        },

        setAdvancedDataOnEdit() {
            const _ccloneInfos = cloneDeep(this.ccloneToEdit)
            // TODO remove this crazy code line used to trigger handler on ccloneMode
            this.ccloneMode.clusterOnly = _ccloneInfos.cluster_only === '0' ? '1' : '0'
            // advanced cclone mode
            this.ccloneMode.versionedProfiles = _ccloneInfos.is_profile_versioned
            this.ccloneMode.clusterOnly = _ccloneInfos.cluster_only
            // positive event
            if (_ccloneInfos.positive_events !== '') {
                const positiveParsed = JSON.parse(_ccloneInfos.positive_events)
                // we need to retrieve item from store to get its jsonKey.name
                const positiveParsedFromStore = find(this.positiveEventsData, _data => {
                    return isEqual(positiveParsed.ids, _data.jsonKey.ids) && positiveParsed.type === _data.jsonKey.type
                })
                if (!isNil(positiveParsedFromStore)) {
                    this.setSelectedEvent({ eventType: 'positive', event: positiveParsedFromStore })
                }
            }
            // negative event
            if (_ccloneInfos.negative_events !== '') {
                this.setSelectedEvent({ eventType: 'database', event: false })
                const negativeParsed = JSON.parse(_ccloneInfos.negative_events)
                // we need to retrieve item from store to get its jsonKey.name
                const negativeParsedFromStore = find(this.negativeEventsData, _data => {
                    return isEqual(negativeParsed.ids, _data.jsonKey.ids) && negativeParsed.type === _data.jsonKey.type
                })
                if (!isNil(negativeParsedFromStore)) {
                    this.setSelectedEvent({ eventType: 'negative', event: negativeParsedFromStore })
                }
            }
        },

        buildSettings() {
            let firstPartySettings, thirdPartySettings
            if (this.ccloneMode.selectedMode === FIRST_PARTY_MODE || this.ccloneMode.selectedMode === FIRST_AND_THIRD_PARTY_MODE) {
                let allowed_criteria = []
                for (const firstPartyData of this.firstPartyData) {
                    if (
                        !isEqual(firstPartyData.jsonKey.type, 'Campaign') &&
                        !isEqual(firstPartyData.jsonKey.type, 'Conversion') &&
                        includes(this.firstPartySelection, firstPartyData.jsonKey.name)
                    ) {
                        allowed_criteria = [...allowed_criteria, { ids: firstPartyData.jsonKey.ids, type: firstPartyData.jsonKey.type }]
                    }
                }
                firstPartySettings = {
                    '1stParty': { allowed_criteria }
                }
            }
            if (this.ccloneMode.selectedMode === THIRD_PARTY_MODE || this.ccloneMode.selectedMode === FIRST_AND_THIRD_PARTY_MODE) {
                thirdPartySettings = {
                    '3rdParty': {
                        cluster_only: this.ccloneMode.clusterOnly === '0' ? false : true,
                        is_profile_versioned: this.ccloneMode.versionedProfiles === '0' ? false : true
                    }
                }
            }
            if (this.ccloneMode.selectedMode === FIRST_AND_THIRD_PARTY_MODE) {
                return { ...firstPartySettings, ...thirdPartySettings }
            }

            return this.ccloneMode.selectedMode === FIRST_PARTY_MODE ? firstPartySettings : thirdPartySettings
        },

        async saveForm() {
            if (this.processing) return // Prevent multiple creation
            const _ccloneInfo = {
                ...this.ccloneInfo,
                start_date: dayjs(this.startDate).format('YYYY-MM-DD'),
                training_and_testing_period:
                    dayjs(this.endDate)
                        .endOf('day')
                        .diff(dayjs(this.startDate).startOf('days'), 'days') + 1,
                positive_events: { type: this.positiveEvent.jsonKey.type, ids: this.positiveEvent.jsonKey.ids },
                negative_events: this.databaseEvent ? '' : { type: this.negativeEvent.jsonKey.type, ids: this.negativeEvent.jsonKey.ids },
                cluster_only: this.ccloneMode.selectedMode === FIRST_PARTY_MODE ? '0' : this.ccloneMode.clusterOnly,
                is_profile_versioned: this.ccloneMode.selectedMode === FIRST_PARTY_MODE ? '0' : this.ccloneMode.versionedProfiles,
                settings: this.buildSettings()
            }
            this.processing = true
            if (!this.isEditing) {
                await this.createCclone({ ccloneInfo: _ccloneInfo })
                this.retrieveCcloneList()
            }
            else {
                const params = { _ccloneInfo, ccloneId: this.ccloneToEdit.id }
                await this.editCclone(params)
                this.retrieveCcloneList()
            }

        },

        debouncedCheckLabel: debounce(function(label) {
            const hasMoreThanAscii = [...label].some(char => char.charCodeAt(0) > 127)
            if (!hasMoreThanAscii) this.checkLabel(label)
        }, 200),

        checkLabel(label) {
            this.checkCCloneLabels({ label }).then(labels => {
                if (!isEmpty(labels) && (!this.isEditing || this.ccloneInStore.label !== this.ccloneInfo.label)) {
                    this.labelAlreadyExists = true
                } else {
                    this.labelAlreadyExists = false
                }
            })
        },

        displayPositiveEventsModal() {
            this.currentSelectedEvent = this.positiveEvent
            if (!isNil(this.ccloneCriteriaTypes.positive.current)) {
                this.setCriteriaType({ eventType: this.eventType, criteriaType: this.ccloneCriteriaTypes.positive.current, history: 'previous' })
            }
            this.setEventType({ eventType: 'positive' })
            this.isCcloneEvent = true
            this.setDisplayModal({ modal: 'events', isDisplayed: true })
        },

        displayNegativeEventsModal() {
            if (!isNil(this.ccloneCriteriaTypes.negative.current)) {
                this.setCriteriaType({ eventType: this.eventType, criteriaType: this.ccloneCriteriaTypes.negative.current, history: 'previous' })
            }
            this.currentSelectedEvent = isNil(this.negativeEvent) ? { database: true } : this.negativeEvent
            this.setEventType({ eventType: 'negative' })
            this.isCcloneEvent = true
            this.setDisplayModal({ modal: 'events', isDisplayed: true })
        },

        displaySelectFirstPartyDataModal() {
            this.isCcloneFirstParty = true
            this.setDisplayModal({ modal: 'events', isDisplayed: true })
        },

        setMaxDepth(depth) {
            this.ccloneInfo.model_params.maxdepth = depth + 1
        },

        formatBooleans(value) {
            if (value === '0') return false
            else if (value === '1') return true
        }
        // TODO: remove this commented code during sharings integration in cclone form
        // retrieveNeededHierarchy() {
        //     let counter = 0
        //     if (this.customTaxonomies.length > 0) {
        //         for (let customTaxo of this.customTaxonomies) {
        //             let isTaxoInStore = this.hierarchies[customTaxo.id]
        //             if (isNil(isTaxoInStore)) {
        //                 counter++
        //                 this.retrieveItems({ taxoId: toNumber(customTaxo.id) }).finally(() => {
        //                     counter--
        //                     if (counter <= 0) {
        //                         if (this.isEditing) {
        //                             this.setAdvancedDataOnEdit()
        //                             this.isLoading = false
        //                         }
        //                         this.setHierarchyIsAlreadyRetrieved({ value: true })
        //                     }
        //                 })
        //             }
        //         }
        //     } else {
        //         if (this.isEditing) {
        //             this.setAdvancedDataOnEdit()
        //             this.isLoading = false
        //         }
        //         this.setHierarchyIsAlreadyRetrieved({ value: true })
        //     }
        // }
    }
}
</script>
